const redirects = ["/chats"];

export default redirects;
